<template>
    <div>
        <div>组件测试</div>
        <button @click='toShow'>点击显示子组件</button>

        <component v-bind:is="show_component"></component>
    </div>
</template>

<script>
    export default {
        name: "Wp_c_test",
        data() {
            return {
                show_component: 'Wp_jd_select',
                open_id: '',
            }
        },
        created() {
            let page = this.$common.getUrlKey('p');
            this.open_id = this.$common.getUrlKey('open_id');
            if (page) {
                this.show_component = page
            }
        },
        methods: {
            toShow: function () {
                let arr = ["Wp_jd_select", "Wp_jd_my", "Wp_jd_data"];
                let index = arr.indexOf(this.show_component);
                if (index < 2) {
                    this.show_component = arr[index + 1];
                } else {
                    this.show_component = arr[0];
                }
            }
        },
        components: {
            // Wp_jd_my,
            // Wp_jd_select,
            'Wp_jd_select': () => import('./Wp_jd_select'),
            'Wp_jd_my': () => import('./Wp_jd_my'),
            'Wp_jd_data': () => import('./Wp_jd_data'),
        }
    }
</script>

<style scoped>

</style>